export default "__VITE_ASSET__BUS0xDEA__"